import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  galleryContainer: {
    padding: theme.spacing(3),
    minHeight: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default function PlantPhotoGallery({ plants, onPlantClick }) {
  const classes = useStyles();

  return (
    <Box className={classes.galleryContainer}>
      <Typography color="textSecondary">
        Photo gallery component will be implemented here
      </Typography>
    </Box>
  );
}